import type { components } from '~/api/openapi';

export type Permission = components['schemas']['Permission'];
export type AccountType = components['schemas']['UserDto']['accountType'];

export function hasPermission(
  permissions: Permission[] | undefined,
  permission: Permission
): boolean {
  return permissions?.includes(permission) ?? false;
}

export function isCreatorLike(accountType: AccountType | undefined): boolean {
  return accountType === 'CREATOR' || accountType === 'EDITOR';
}
